__turbopack_context__.v({
  "frame": "AnchoredImage-module__fw9Jdq__frame",
  "image": "AnchoredImage-module__fw9Jdq__image",
});
